// Characters we will consider as markers for new words
const newWordCharacters = new RegExp(/[-_ .](.)/g);
const stripCharacters = new RegExp(/[\W_]+/g);

/**
 * Convert string to a proper camelCased string
 * @param str String you want camelCased
 * @returns camelCased string
 */
export const toCamelCase = (str: string = '') => {
	// for the wild west javascript that will be calling this and maybe made this necessary
	// ensure we are working with a string - doesn't hurt to re-assert this for now
	if (str == null) str = '';
	str = str.toString();

	// First check if the first character is alphanumeric and strip it if it is not
	// Otherwise we will end up with a capital first word once non alphanumeric characters are removed
	// We dont' want to remove all of them yet as things like underscors and dashes symbolize a need for a new capitalized word
	str = str.replace(/^[\W]+/g, '');

	// Then check if we have capital letters already ("GEO", "NLO / Country", "FileType", etc)
	const capitalizedArray = str.match(/([A-Z]?[^A-Z]*)/g)?.slice(0, -1) || [];
	let newStr = '';

	// If we have more than one capital letter we need to do and check some things ourselves
	if (capitalizedArray.length > 1) {
		for (let i = 0, c = capitalizedArray.length; i < c; i++) {
			// If we are not at the last index
			// and this char is capital
			// and next char is capital as well
			// this maintains all cap words in the string
			if (
				i < c - 1 &&
				capitalizedArray[i].toUpperCase() === capitalizedArray[i] &&
				capitalizedArray[i + 1].toUpperCase() === capitalizedArray[i + 1]
			) {
				newStr += capitalizedArray[i];
			} else {
				// If this is the first word and it contains a new word chartacter as defined above
				if (!i && newWordCharacters.test(capitalizedArray[i])) {
					capitalizedArray[i] = capitalizedArray[i]
						.replace(newWordCharacters, ($1) => $1.toUpperCase())
						.replace(/^(.)/, ($1) => $1.toLowerCase())
						.replace(stripCharacters, '');

					newStr += capitalizedArray[i];
				} else {
					// If it is the first word then we want it lowercase
					if (!i) {
						newStr += capitalizedArray[i]
							.toLowerCase()
							.replace(stripCharacters, '');
					} else {
						newStr += capitalizedArray[i]
							.replace(newWordCharacters, ($1) => $1.toUpperCase())
							.replace(stripCharacters, '');
					}
				}
			}
		}
		return newStr.replace(stripCharacters, '');
	}

	// If we are here then this is a standard camelCase issue
	return str
		.replace(newWordCharacters, ($1) => $1.toUpperCase())
		.replace(/^(.)/, ($1) => $1.toLowerCase())
		.replace(stripCharacters, '');
};
